"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const chat_1 = require("../../chat");
const constants_1 = require("../../constants");
const sendLiveSpaceData = ({ liveSpaceData, action, spaceId, pgpPrivateKey, signer, env, }) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    yield (0, chat_1.send)({
        receiverAddress: spaceId,
        pgpPrivateKey,
        env,
        signer,
        messageType: constants_1.MessageType.META,
        messageObj: {
            content: action,
            info: {
                affected: [],
                arbitrary: liveSpaceData,
            },
        },
    });
});
exports.default = sendLiveSpaceData;
//# sourceMappingURL=sendLiveSpaceData.js.map